import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Checkbox, Select, Radio } from 'react-daisyui';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ExportMultiStudyResponsesCSVModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: (data: any) => void;
  selectedData?: Set<any>; // optional
  title?: string;  // optional
  content?: React.ReactNode;  // optional
}

const ExportMultiStudyResponsesCSVModal: React.FC<ExportMultiStudyResponsesCSVModalProps> = ({
  isOpen,
  onClose,
  onAction,
  title = 'Confirm Modal', // Default value for title
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>('complete');
  const [sortByDate, setSortByDate] = useState(true);

  // Wraps the action and resolves if its async or if its sync
  const onActionWrapper = (onAction: (data: any) => void) =>{
    setLoading(true);
    console.log(sortByDate)
    Promise.resolve(onAction({"sort_by_date": sortByDate, "selected_option": selectedOption})).catch((e)=>{
      toast.error(`Unknown error completing the action. ${e}`)
    }).finally(()=>{
      setLoading(false);
    })
  }

  useEffect(() => {
    isOpen && setLoading(false);
  }, [isOpen]);

  useEffect(() => {
    // Set default options 
    setSelectedOption('complete')
    setSortByDate(true)
  }, []);

  return (
    <Modal open={isOpen}>
      <Modal.Header className="text-2xl font-bold">{title}</Modal.Header>
      <Modal.Body>
    <Form className="w-128">
        <h1 className="font-bold mb-5">Please select the options for the CSV export.</h1>
        
        <div className="mb-5">
            <h2 className="mb-2 font-medium">Completion Status:</h2>
            <Form.Label title="Complete">
                <Radio name="completionStatus" checked={selectedOption === 'complete'} onChange={() => setSelectedOption('complete')} />
            </Form.Label>
            <Form.Label title="Incomplete">
                <Radio name="completionStatus" checked={selectedOption === 'incomplete'} onChange={() => setSelectedOption('incomplete')} />
            </Form.Label>
            <Form.Label title="All">
                <Radio name="completionStatus" checked={selectedOption === 'all'} onChange={() => setSelectedOption('all')} />
            </Form.Label>
        </div>

        <div>
          <Form.Label title="Sort by date (Newest to Oldest)">
            <Checkbox name="date" checked={sortByDate} onChange={(e) => setSortByDate(e.target.checked)} />
            </Form.Label>
        </div>
    </Form>
</Modal.Body>


      <Modal.Actions>
        <Button id='ModalCancelButton' type="button" disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button
           id='ModalConfirmButton'
          type="button"
          color="primary"
          className={loading ? 'pointer-events-none' : ''}
          onClick={loading ? undefined : () => onActionWrapper(onAction)}
        >
          {loading ? (
            <div className="flex items-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Loading...
            </div>
          ) : (
            'Confirm'
          )}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ExportMultiStudyResponsesCSVModal;
